export default __webpack_public_path__ + "static/media/exclamation.49eccb4f.png";